<template>
    <div class="main">
        <b-loading
        :active.sync="isLoading"
        :canCancel="true"
        ></b-loading>
        <div class="columns is-fullheight">
        <div class="column is-2 is-sidebar-menu">
            <aside class="menu">
            <p
                class="menu-label"
                v-if="isAdmin"
            >
                General
            </p>
            <ul class="menu-list">
                <li>
                <a
                    :class="content == 'list_file' ? 'is-active' : 'color-white'"
                    @click="swap_content('list_file')"
                >
                    Download Documents
                </a>
                </li>
                <li>&nbsp;</li>
                <li>
                <a
                    :class="content == 'upload_file' ? 'is-active' : 'color-white'"
                    @click="swap_content('upload_file')"
                >
                    Upload Documents
                </a>
                </li>
                <li v-if="sheetURL">&nbsp;</li>
                <li v-if="sheetURL">
                <a
                    :class="content == 'timesheet' ? 'is-active' : 'color-white'"
                    @click="swap_content('timesheet')"
                >
                    Payroll Worksheet
                </a>
                </li>
                <li>&nbsp;</li>
                <li>
                <a
                    :class="content == 'share_screen' ? 'is-active' : 'color-white'"
                    @click="alert()"
                >
                    Share Screen {{ isAdmin ? '(Chrome)' : '' }}
                </a>
                </li>
            </ul>
            <p
                class="menu-label"
                v-if="isAdmin"
            >
                Administration
            </p>
            <ul
                class="menu-list"
                v-if="isAdmin"
            >
                <li v-if="isAdmin"><a
                    :class="content == 'manage_user' ? 'is-active' : 'color-white'"
                    @click="swap_content('manage_user')"
                >Manage Users</a></li>
            </ul>
            </aside>
        </div>

        <div class="column is-main-content">
            <div v-if="content == 'list_file'">
            <div v-if="isAdmin">
                <admin-download-table
                :isAdmin="isAdmin"
                :files="files"
                :users="arrUsers"
                :isLoading="isLoading"
                ></admin-download-table>
            </div>

            <div
                class=""
                v-else
            >
                <download-table
                :isAdmin="isAdmin"
                :files="files"
                :isLoading="isLoading"
                ></download-table>
            </div>
            </div>

            <div v-if="content == 'upload_file'">
            <upload-table
                :isAdmin="isAdmin"
                :files="uploadFiles"
                :users="arrUsers"
            ></upload-table>

            <section class="section">
                <div class="columns">
                <div class="column is-one-quarter is-hidden-touch"></div>
                <div class="column">
                    <div class="field">
                    <div class="control">
                        <textarea
                        class="textarea is-info"
                        name="upload_note"
                        v-model="notes"
                        rows="5"
                        placeholder="Enter your notes here..."
                        ></textarea>
                    </div>
                    </div>

                    <div class="field">
                    <div class="file is-centered is-boxed is-default has-name">
                        <label>
                        <b-field class="file">
                            <b-upload v-model="selectedFiles">
                            <a class="button is-default">
                                <b-icon icon="upload"></b-icon>
                                <span>Choose file</span>
                            </a>
                            </b-upload>
                            <span
                            class="file-name"
                            v-if="selectedFiles"
                            >
                            {{ selectedFiles.name ? selectedFiles.name : 'No file chosen' }}
                            </span>
                        </b-field>
                        </label>
                    </div>
                    </div>

                    <progress
                    id="upload_progress_bar"
                    class="progress is-primary"
                    :value="progress"
                    max="100"
                    >{{ progress }}%</progress>

                    <div v-if="isAdmin">
                    <label class="label">For Client:</label>
                    <b-select
                        v-model="selectedUser"
                        :expanded="true"
                    >
                        <option
                        :key="id"
                        :value="id"
                        v-for="(user, id) in arrUsers"
                        >
                        <template v-if="!user.email">
                            -- Select One --
                        </template>
                        <template v-else>
                            {{ user.displayName}} ({{ user.email }})
                        </template>
                        </option>
                    </b-select>
                    </div>

                    <div class="columns">
                    <div class="column is-one-third">&nbsp;</div>
                    <div class="column is-one-third"><br />
                        <button
                        type="button"
                        class="button is-large is-primary"
                        name="button"
                        :disabled="isAdmin && !selectedUser"
                        @click="upload"
                        >Submit</button>
                    </div>
                    </div>
                </div>
                <div class="column is-one-quarter is-hidden-touch"></div>
                </div>
            </section>
            </div>

            <div
            class="has-text-centered"
            v-if="content == 'timesheet'"
            >
            <div v-if="isAdmin">
                <div class="columns">
                <div class="column is-one-third">&nbsp;</div>
                <div class="column is-one-third"><br />
                    <b-select
                    v-model="selectedUser"
                    :expanded="true"
                    >
                    <option
                        :key="id"
                        :value="id"
                        v-for="(user, id) in arrUsers"
                    >
                        <template v-if="!user.email">
                        -- Select One --
                        </template>
                        <template v-else>
                        {{ user.displayName}} ({{ user.email }})
                        </template>
                    </option>
                    </b-select>
                    <br />
                </div>
                </div>

                <iframe
                v-if="arrSheetURL[selectedUser]"
                :src="arrSheetURL[selectedUser]"
                frameborder="0"
                marginheight="0"
                marginwidth="0"
                width="100%"
                height="100%"
                scrolling="auto"
                style="overflow:hidden;height:800px;width:100%"
                ></iframe>
            </div>
            <div v-else>
                <iframe
                v-if="sheetURL"
                :src="sheetURL"
                frameborder="0"
                marginheight="0"
                marginwidth="0"
                width="100%"
                height="100%"
                scrolling="auto"
                style="overflow:hidden;height:800px;width:100%"
                ></iframe>
            </div>

            </div>

            <div
            class="has-text-centered"
            v-if="content == 'share_screen'"
            >
            <b-button
                type="is-primary"
                style="margin-top: 50px;"
                @click="alert"
            >
                {{ isAdmin ? 'View Client Shared Screen' : 'Open Shared Screen Window'}}
            </b-button>
            </div>

            <div v-if="content == 'manage_user' && isAdmin">
            <manage-users v-if="isAdmin"></manage-users>
            </div>
        </div>
        </div>

    </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import ManageUsers from "./client_portal/ManageUsers.vue";
import DownloadTable from "./client_portal/DownloadTable.vue";
import AdminDownloadTable from "./client_portal/AdminDownloadTable.vue";
import UploadTable from "./client_portal/UploadTable.vue";
import { ToastProgrammatic as Toast } from "buefy";

// var writeFileAtomic = require('write-file-atomic')
// const worker = require("worker_threads");
// /*
// var functions = require("firebase-functions");
// var admin = require("firebase-admin");
// var cors = require("cors")({ origin: true });
// */
export default {
  name: "Admin",
  data() {
    return {
        isAdmin: false,
        layout: "grid",
        content: "list_file",
        files: [],
        uploadFiles: [],
        sortColumn: "fileName",
        sortOrder: "asc",
        user: {},
        progress: 0,
        isLoading: true,
        isPaginated: true,
        defaultSortDirection: "asc",
        currentPage: 1,
        perPage: 5,
        defaultOpenedDetails: [1],
        arrUsers: {},
        selectedUser: null,
        notes: null,
        selectedFiles: {},
        sheetURL: "",
        arrSheetURL: [],
        isLoading: false
    };
  },
  watch: {
    perPage: function(val) {
      this.isPaginated = val == 0 ? false : true;
    }
  },
  components: {
    "manage-users": ManageUsers,
    "download-table": DownloadTable,
    "admin-download-table": AdminDownloadTable,
    "upload-table": UploadTable
  },
  methods: {
    alert() {
      if (this.isAdmin) {
        window.open(
            "https://screen.daihuamacc.com/#18-fluttering-leopards-jogged-knottily",
            "",
            "toolbar=no,location=no"
        );
      } else {
        window.open(
            "https://screen.daihuamacc.com/#host",
            "",
            "toolbar=no,location=no"
        );
      }
    },
    users() {
      let that = this;
      var userRef = firebase
        .database()
        .ref("users")
        .orderByChild("email");
      userRef.once("value", function(snapshot) {
            snapshot.forEach(function(childSnapshot) {
                var childKey = childSnapshot.key;
                var childData = childSnapshot.val();
                that.arrUsers[childKey] = childData;
            });
      });
    },
    fetchDownloadDocuments(uid) {
        const that = this
        let myFiles = [];

        that.isLoading = true;
        const refDownloadPath   = that.isAdmin ? "uploads" : "downloads/" + uid;
        const downloadsRef      = firebase.database().ref(refDownloadPath);
        downloadsRef.once("value", function(snapshot) {
          snapshot.forEach(function(childSnapshot) {
            var childData = childSnapshot.val();
            if (that.isAdmin) {
                Object.keys(childData).forEach(childKey =>
                    myFiles.push(childData[childKey])
                );
            } else {
                myFiles.push(childData);
            }
          });
          that.isLoading = false;
        });
        that.files = myFiles;
    },
    fetchUploadDocuments(uid) {
        const that = this
        let myUploadFiles = [];

        const refUploadPath = this.isAdmin ? "downloads" : "uploads/" + uid;

        const uploadsRef = firebase.database().ref(refUploadPath);

        uploadsRef.once("value", function(snapshot) {
          snapshot.forEach(function(childSnapshot) {
            let childData = childSnapshot.val();
            if (that.isAdmin) {
                Object.keys(childData).forEach(childKey =>
                    myUploadFiles.push(childData[childKey])
                );
            } else {
                myUploadFiles.push(childData);
            }
          });
          that.isLoading = false;
        });

        this.uploadFiles = myUploadFiles;
    },
    fetchUsers(uid) {
        const that = this;
        const refUserPath = that.isAdmin ? "users" : "users/" + uid;
        const usersRef = firebase.database().ref(refUserPath);
        usersRef.once("value", function(snapshot) {
          snapshot.forEach(function(childSnapshot) {
            var childKey = childSnapshot.key;
            var childData = childSnapshot.val();
            if (that.isAdmin) {
              if (childKey === uid) {
                that.sheetURL =
                  typeof childData.sheetURL !== "undefined"
                    ? childData.sheetURL
                    : "";
              }
              that.arrSheetURL[childKey] =
                typeof childData.sheetURL !== "undefined"
                  ? childData.sheetURL
                  : "";
            } else {
              if (childKey === "sheetURL") {
                that.sheetURL =
                  typeof childData !== "undefined" ? childData : "";
              }
            }
          });
          that.isLoading = false;
        });
    },
    swap_content(content_type) {
      this.content = content_type;
    },
    clearForm() {
      this.selectedUser = null;
      this.notes = null;
      this.selectedFiles = {};
      this.progress = 0;
    },
    upload() {
        let that = this;
        const vm = this;
        var storage = firebase.storage();
        var database = firebase.database();
        var user = firebase.auth().currentUser;
        var uid = user.uid;
        var email = user.email;
        var folder = "uploads";
        if (this.isAdmin) {
            uid = this.selectedUser;
            email = this.arrUsers[this.selectedUser].email;
            folder = "downloads";
        }

        // var file = document.getElementById("files").files[0];
        let file = this.selectedFiles;
        var storageRef = firebase.storage().ref();

        let fileExt = this.getFileExtension(file.name);
        let fileName = file.name.replace(/\.[^/.]+$/, "");
        let newFileName =
            _.snakeCase(fileName) + "_" + this.getDatetime() + "." + fileExt;
        //dynamically set reference to the file name
        var thisRef = storageRef.child(
            "users/" + email + "/" + folder + "/" + newFileName
        );

        //put request upload file to firebase storage
        thisRef.put(file).on(
            "state_changed",
            function(snapshot) {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            that.progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            //   console.log('Upload is ' + that.progress + '% done');
            switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                //   console.log('Upload is paused');
                break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                //   console.log('Upload is running');
                break;
            }
            },
            function(error) {
            // Handle unsuccessful uploads
            },
            function() {
            // Handle successful uploads on complete
            //    console.log('Uploaded a blob or file!');
            console.log(uid);
            // Get a key for a new Post.
            var newPostKey = database
                .ref()
                .child("users")
                .push().key;
            var updates = {};
            updates["/users/" + uid + "/" + newPostKey] = {
                uid: user.uid,
                email: user.email,
                timestamp: firebase.database.ServerValue.TIMESTAMP
            };
            axios
                .get("https://api.hostip.info/get_json.php")
                .then(function(response) {
                try {
                    updates["/users/" + uid + "/" + newPostKey] = {
                    uid: user.uid,
                    email: user.email,
                    ip: response.data.ip,
                    timestamp: firebase.database.ServerValue.TIMESTAMP
                    };
                    database.ref().update(updates);
                } catch (e) {
                    database.ref().update(updates);
                }
                })
                .catch(function(error) {
                console.log(error);
                database.ref().update(updates);
                });

            thisRef
                .getMetadata()
                .then(function(metadata) {
                updates["/" + folder + "/" + uid + "/" + newPostKey] = {
                    downloadUrl: metadata.downloadURLs[0],
                    originalFile: file.name,
                    fileExt: fileExt,
                    fileName: newFileName,
                    timestamp: firebase.database.ServerValue.TIMESTAMP,
                    size: metadata.size,
                    contentType: metadata.contentType,
                    fullPath: metadata.fullPath,
                    timeCreated: metadata.timeCreated,
                    timeUpdated: metadata.updated,
                    notes: that.notes
                };
                database.ref().update(updates);
                //    console.log(metadata);
                Toast.open({
                    duration: 5000,
                    message: "Uploaded Successfully",
                    type: "is-success"
                });
                that.clearForm();
                //    window.location.href = '/admin';
                that.fetchDownloadDocuments(uid);
                that.fetchUploadDocuments(uid);

                })
                .catch(function(error) {
                console.log(error);
                Toast.open({
                    duration: 5000,
                    message:
                    "Your file did not go through. Please upload it again.",
                    type: "is-danger"
                });
                // Uh-oh, an error occurred!
                });
            }
        );
    },
    getFileExtension(filename) {
      return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
    },
    getDatetime() {
      return moment().format("YYYYMMDD_HHMMSS");
    },
    setSortColumn: function(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      }
      this.sortColumn = column;
    }
  },
  beforeMount() {
    this.users();
  },
  mounted() {
    const that = this;
    const vm = this;
    firebase.auth().onAuthStateChanged(function(user) {
        let sessionTimeout = null;
      if (user) {
        //   router.push({ name: 'Home'})
         // Fetch the decoded ID token and create a session timeout which signs the user out.
        // user.getIdTokenResult().then((idTokenResult) => {
        // // Make sure all the times are in milliseconds!
        //     const authTime = idTokenResult.claims.auth_time * 1000;
        //     const sessionDuration = 1000 * 60 * 60 * 24 * 30;
        //     const millisecondsUntilExpiration = sessionDuration - (Date.now() - authTime);
        //     sessionTimeout = setTimeout(() => auth.signOut(), millisecondsUntilExpiration);
        // });
        const interval = setInterval(function() {
        // method to be executed;
            user.refreshToken;
            console.log('clear token')
        }, 60000);

        clearInterval(interval);

        that.isAdmin = user.uid === "wv9Xc9RugvRXDDLLpqLxpJQjNim2";

        // user.updateProfile({
        //     displayName: "Steven Chau",
        //     photoURL: "https://avatars3.githubusercontent.com/u/989277?s=460&v=4"
        //   }).then(function() {
        //       console.log('Update successful ');
        //   }).catch(function(error) {
        //       console.log(error);
        //   });

        const uid = user.uid;
        that.fetchDownloadDocuments(uid);
        that.fetchUploadDocuments(uid);
        that.fetchUsers(uid);

      } else {
            // Clear the session timeout.
            // sessionTimeout && clearTimeout(sessionTimeout);
            // sessionTimeout = null;
            const that = this
        firebase.auth().signOut().then(function() {
          console.log('sign out')
                that.$router.push('/');
        // Sign-out successful.
        }).catch(function(error) {
        // An error happened.
        });
      }
    });

    // fileButton.addEventListener('change', function(e){
    //     var file = e.target.files[0];
    //     var storageRef = firebase.storage().ref(file.name);
    //     storageRef.put(file);
    // });
  }
};
</script>
<style lang="scss" >
html {
    background-image: url("./../assets/images/dark-wood-bkg.jpg");
    background-position: top center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    background-color: #999;
}

.menu-list a:hover {
    background-color: #f5f5f5 !important;
    color: #4a4a4a !important;
}

.menu-list a,
.pagination-link,
.label,
.tabs a {
    color: #ffffff !important;
}

.tabs li.is-active a {
  color: #7957d5 !important;
}


ul {
    list-style: none !important;
}
.file.is-boxed.has-name .file-name {
    margin-left: 10px;
    border-radius: 5px !important;
    border-width: 1px 1px 1px 1px !important;
}

/* LG */

@media (min-width: 1200px) {
    .grid li {
        width: 25%;
    }
}

/* MD */

@media (min-width: 992px) and (max-width: 1199px) {
    .grid li {
        width: 33%;
    }
}

/* SM */

@media (min-width: 768px) and (max-width: 991px) {
    .grid li {
        width: 50%;
    }
}

/* XS */

@media (max-width: 767px) {
    .grid li {
        width: 100%;
    }
}

/* Grid layout */
.grid {
    list-style: none;
    margin: 0 auto;
    padding: 20px;
    width: 100%;
}

.grid li {
    display: inline-block;
    position: relative;
}

.grid li:after {
    content: "";
    display: block;
    padding-bottom: 52%;
}

.grid li a {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    // border: 2px solid #fff;
    // height: 99%;
    position: absolute;
    // width: 98%;
}

.grid li a:hover {
    color: #fff;
}

/* List layout */
.list {
    background-color: #ddedfb;
    list-style: none;
    margin: 0 auto;
    padding: 0;
    text-align: left;
    width: 100%;
}

.list li {
    border-bottom: 1px solid #fff;
    overflow: hidden;
    padding: 20px;
    transition: background 0.2s linear;
}

.list li:hover {
    background-color: #fff;
}

.list li a {
    display: table;
    width: 100%;
}

.list li img {
    border: none;
    display: table-cell;
    height: 120px;
    vertical-align: middle;
    width: 120px;
}

.list li:hover p {
    color: #0096d4;
}

.list li p {
    color: #000;
    display: table-cell;
    font-weight: 700;
    padding: 0 0 0 15px;
    vertical-align: middle;
    width: 100%;
}

a.color-white {
    color: #ffffff;
}
.file-name {
    border-width: 1px;
}
.img-circle {
    border-radius: 50%;
}
$sizeUnit: rem;
$marginKey: "m";
$paddingKey: "p";
$separator: "-";
$sizes: (
  ("none", 0),
  ("xxs", 0.125),
  ("xs", 0.25),
  ("sm", 0.5),
  ("md", 1),
  ("lg", 2),
  ("xl", 4),
  ("xxl", 8)
);
$positions: (("t", "top"), ("r", "right"), ("b", "bottom"), ("l", "left"));

@function sizeValue($key, $value) {
  @return if($key == "none", 0, $value + $sizeUnit);
}

@each $size in $sizes {
  $sizeKey: nth($size, 1);
  $sizeValue: nth($size, 2);
  .#{$marginKey}#{$separator}#{$sizeKey} {
    margin: sizeValue($sizeKey, $sizeValue);
  }
  .#{$paddingKey}#{$separator}#{$sizeKey} {
    padding: sizeValue($sizeKey, $sizeValue);
  }
  @each $position in $positions {
    $posKey: nth($position, 1);
    $posValue: nth($position, 2);
    .#{$marginKey}#{$separator}#{$posKey}#{$separator}#{$sizeKey} {
      margin-#{$posValue}: sizeValue($sizeKey, $sizeValue);
    }
    .#{$paddingKey}#{$separator}#{$posKey}#{$separator}#{$sizeKey} {
      padding-#{$posValue}: sizeValue($sizeKey, $sizeValue);
    }
  }
}

$sizes: (0, 10, 15, 20, 25, 30, 50);
$positions: ("top", "left", "bottom", "right");

@each $size in $sizes {
  .u-m-#{$size} {
    margin: $size + px;
  }
  .u-p-#{$size} {
    padding: $size + px;
  }
}
</style>

/*
Name, Creation Date, Expiration Date, Type, Size, Notes
 */



// WEBPACK FOOTER //
// Admin.vue?ae084734